import React, { useEffect, useMemo, useState } from "react";
import { ReportAPI } from "../../api/apiClient";

interface Props {
  projectId: number;
  //selectedDate: string;
}

interface ManPowerRow {
  componentGroupNo: number;
  componentGroup: string;
  componentNo: number;
  component: string;
  date: string;
  onRoll: number;
  vendor: string;
  billable: boolean;
  vendorNo: number;
}

export default function ManPowerStatementReport({
  projectId,
 // selectedDate,
}: Props) {
  const [data, setData] = useState<ManPowerRow[]>([]);
  const [loading, setLoading] = useState(false);

  // ✅ Auto load when date changes
  // Auto load when projectId changes

  useEffect(() => {
   // if (!selectedDate) return;
    if (!projectId) return;


    const loadReport = async () => {
      try {
        setLoading(true);

        const result = await ReportAPI.getManPowerStatement({
          //qDate: selectedDate,
          //endDate: selectedDate,
          project: projectId,
          vendor: -1,
          cmp: 0,
        });

        setData(result as ManPowerRow[]);
      } catch (err) {
        console.error("Manpower API error:", err);
      } finally {
        setLoading(false);
      }
    };

    loadReport();
  }, [projectId]); //selectedDate

  // ✅ Group by component
  const grouped: Record<string, number> = useMemo(() => {
    return data.reduce((acc: Record<string, number>, item) => {
      const key = item.component;

      if (!acc[key]) {
        acc[key] = 0;
      }

      acc[key] += item.onRoll;
      return acc;
    }, {});
  }, [data]);

  // ✅ Sort highest first
  const sortedTeams = useMemo(() => {
    return Object.entries(grouped).sort((a, b) => b[1] - a[1]);
  }, [grouped]);

  // ✅ Total manpower
  const totalManpower = useMemo(() => {
    return Object.values(grouped).reduce((sum, value) => sum + value, 0);
  }, [grouped]);

  return (
    //<div className="bg-white rounded shadow border overflow-hidden">
    <div className="bg-white rounded-2xl shadow-md border border-gray-200 overflow-hidden">


      {/* Header */}
      {/*<div className="bg-blue-800 text-white px-4 py-3 font-semibold">*/}
      <div className="bg-[#1788ac] text-white px-4 py-3 font-semibold">

        TASK TEAMS
      </div>

      {/* Body */}
      <div className="p-4 space-y-3">

        {loading && (
          <div className="text-gray-500">Loading...</div>
        )}

        {!loading && sortedTeams.length === 0 && (
          <div className="text-gray-500">
            No manpower data found.
          </div>
        )}

        {!loading && sortedTeams.length > 0 && (
          <>
            {sortedTeams.map(([team, count]) => (
              <div
                key={team}
                className="flex justify-between text-gray-800 text-base border-b pb-1"
              >
                <span>{team}</span>
                <span className="font-semibold">{count}</span>
              </div>
            ))}

            {/* Total Section */}
            <div className="flex justify-between text-gray-900 font-bold pt-2 border-t mt-2">
              <span>Total</span>
              <span>{totalManpower}</span>
            </div>
          </>
        )}

      </div>

      {/* Bottom Accent */}
      {/*<div className="h-1 bg-green-600"></div>*/}
    </div>
  );
}
